import axios from "axios";

const state = {
  pagination: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["facility_id"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    mustSort: false,
    multiSort: false,
    totalItems: 0,
    rowsPerPageOptions: [25, 50, 75, 100]
  },
  reviews: []
};

const actions = {
  getReviews: ({ commit }) => {
    return axios.get(`/facility-reviews/approval-queue`)
      .then((resp) => {
        commit("commitReviews", resp.data.reviews);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  updateReviewInQueue: ({ dispatch }, payload) => {
    return axios.patch(`/facility-reviews/${payload.id}`, payload)
      .then((resp) => {
        dispatch("getReviews");
        dispatch("snackbar/successMessage", `Successfully updated review`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  deleteReviewFromQueue: ({ dispatch }, id) => {
    return axios.delete(`/facility-reviews/${id}`)
      .then((resp) => {
        dispatch("getReviews");
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  enableReview: ({ dispatch }, id) => {
    return axios.patch(`/facility-reviews/${id}/enable`)
      .then((resp) => {
        dispatch("getReviews");
        dispatch("snackbar/successMessage", `Successfully enabled review`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  disableReview: ({ dispatch }, id) => {
    return axios.patch(`/facility-reviews/${id}/disable`)
      .then((resp) => {
        dispatch("getReviews");
        dispatch("snackbar/successMessage", `Successfully disabled review`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  }
};

const mutations = {
  commitReviews: (state, reviews) => {
    state.reviews = reviews;
  }
};

export default {
  state,
  actions,
  mutations
};
